import type { DevToolsRegistrationPillProps } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsPanel/DevToolsRegistrationPill/index.types';
import { TONE } from 'Modules/softphone/components/SoftphoneDevTools/styles';
import { getSipHealthStatus } from 'Modules/softphone/components/SoftphoneDevTools/utils';
import React from 'react';
import { cn } from '~/lib/utils';

const PILL_TONES = {
  healthy: TONE.ok,
  warning: TONE.warn,
  error: TONE.bad,
} as const;

/**
 * DevToolsRegistrationPill - Whether the softphone can take a call at all
 *
 * The panel used to signal this with a tinted gradient behind the header,
 * which read as decoration.
 */
export const DevToolsRegistrationPill: React.FC<
  DevToolsRegistrationPillProps
> = ({ status }) => {
  const health = getSipHealthStatus(status);
  const tone = PILL_TONES[health];

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-[20px] border py-[3px] pl-[7px] pr-2',
        tone.inset
      )}
    >
      <span
        className={cn('h-1.5 w-1.5 rounded-full', tone.dot, 'animate-pulse')}
      />
      <span
        className={cn(
          'text-[10px] font-semibold uppercase tracking-[0.06em]',
          tone.text
        )}
      >
        {status}
      </span>
    </span>
  );
};
